import {
  FormValidator,
  type FormValidatorContext,
  isEmpty,
  type FormValidatorConfig,
  type FormValidatorSettings,
  SelectableFormElement
} from '@common/index';

export type MaxPartExamQuantityValidatorSettings = FormValidatorSettings;

export type MaxPartExamQuantityValidatorConfig = FormValidatorConfig<MaxPartExamQuantityValidatorSettings>;

export class MaxPartExamQuantityValidator extends FormValidator<MaxPartExamQuantityValidatorSettings> {
  constructor() {
    super();
    this._name = 'maxPartExamQuantity';
    this._settings = {
      invalidMessage: 'form.validator.maxPartExamQuantity.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value)) {
      return;
    }

    const element = context.element.parent?.getChild('educationElementId') as SelectableFormElement;
    const item = element.items.find((item) => item.value === element.value);

    if (!item) {
      return;
    }

    this._valid = value <= item.quantity;

    if (!this._valid) {
      this.addMessage(this._settings.invalidMessage);
    }
  }
}
